/* eslint-disable max-len */
import { Button, Card, Grid } from '@mui/material';
import React, { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import ComponentTextInput from '../../../../Common/ComponentTextinput/ComponentTextInput';
import { setSelectedTab } from '../../redux/oilReportSlice';
import { ConcentrationLabel, severities } from '../../utils/constant';
import { ConcentrationFormProps, MainFields } from '../../utils/types';
import ComponentSelectInput from '../../../../Common/ComponentSelectInput';

export function Concentration({ control, errors }:ConcentrationFormProps) {
  const requiredFields:string[] = useMemo(() => [], []);

  const concFields:MainFields[] = useMemo(() => Object.entries(ConcentrationLabel).map(([field, label]) => ({
    field,
    label,
    isRequired: requiredFields.includes(field),
  })), []);

  const dispatch = useDispatch();

  const handleNext = () => {
    dispatch(setSelectedTab(2));
  };

  return (
    <>
      <Card>
        <div className="customerInfo_container">
          <div className="customerInfo" style={{ color: '#ac0202' }}>Note: Overall Severity is imported from the Excel sheet. Changes made to individual severities will not update it automatically. Update Overall Severity manually if needed.</div>
          <div className="customer_info_checkbox dropdown_side_label">
            <div className="customer_info_header_checkbox">
              <label className="label_Style_Customer" style={{ width: '200px', paddingTop: '10px' }}>Overall Severity</label>
              <ComponentSelectInput
                name="severity"
                errors={errors}
                control={control}
                size="small"
                entries={severities}
              />
            </div>
          </div>
        </div>
        <div className="customerInfo_main_container">
          <Grid container spacing={2}>
            {concFields.map((entry:MainFields) => (
              <Grid key={entry.field} item xs={6} sm={6} md={3} lg={3} xl={2}>
                <div className="div_label_text">
                  <label className="label_Style_Customer">{entry.label}</label>
                  {entry?.field?.includes('SEV') ? (
                    <ComponentSelectInput
                      name={entry.field}
                      required={entry.isRequired}
                      errors={errors}
                      control={control}
                      size="small"
                      entries={severities}
                    />
                  ) : (
                    <ComponentTextInput
                      control={control}
                      required={entry.isRequired}
                      capitalizeFirst
                      errors={errors}
                      inputProps={{ maxLength: 30 }}
                      name={entry.field}
                      id={entry.field}
                      size="small"
                    />
                  )}
                </div>
              </Grid>
            ))}
          </Grid>
        </div>
      </Card>
      <br />
      <Grid item md={12} sm={12} xs={12}>
        <div className="save_and_next_div">
          <div className="button_margin_left">
            <Button className="button_save_and_next" onClick={handleNext}>Next</Button>
          </div>
        </div>
      </Grid>
    </>
  );
}
